'use strict';

function isInput (elem) {
  return elem && elem.nodeName && elem.nodeName.toLowerCase() === 'input';
}

module.exports = isInput;



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/isInput.js
// module id = 53
// module chunks = 0